import { useQuery } from '@tanstack/react-query';

import apiClient from '../../lib/api-client';

export const productDiffKeys = {
  all: ['product-diffs'] as const,
  detail: (opportunityId: string, productId: string) =>
    [...productDiffKeys.all, opportunityId, productId] as const,
};

interface ProductDiffResponse {
  success: boolean;
  diff: string | null;
  error?: string;
}

async function fetchProductDiff(opportunityId: string, productId: string): Promise<string | null> {
  const response = await apiClient.get<ProductDiffResponse>(
    `/comparisons/${opportunityId}/diff/${productId}`
  );
  return response.data.diff ?? null;
}

export function useProductDiff(opportunityId: string, productId: string) {
  return useQuery({
    queryKey: productDiffKeys.detail(opportunityId, productId),
    queryFn: () => fetchProductDiff(opportunityId, productId),
    enabled: !!opportunityId && !!productId,
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    retry: false,
  });
}
